import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { storeQueries } from '@as-react/common-queries';
import { LocationSearchType, StoreFinderType } from '@as-react/common-types';
import { useQueries } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchAPI from '../../../api/search/SearchAPI';
import { SELECTED_STORE_STORAGE_KEY } from '../../../constants/StorageKeysConstants';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { basketActions } from '../../../redux/basket/actions/BasketActions.creators';
import { makeGetBasketCCPopupState } from '../../../redux/basket/selectors/BasketSelector';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import { StoreFinderPopup } from '../../product-detail/store-finder-popup/StoreFinderPopup';
import { useProductListerContext } from '../context';
export const InStoreFilterFlyout = () => {
    var _a;
    const popupState = useSelector(makeGetBasketCCPopupState());
    const { urlState, inStoreFilter, updateStoreId, updateInStoreFilter } = useProductListerContext();
    const activeStoreId = urlState.storeId;
    const dispatch = useDispatch();
    const { defaultRequestParams, servicesEndpoint, authenticationConfig, isShopLanding } = useAemConfig();
    const [locationSearchParams, setLocationSearchParams] = useState();
    const { getClickAndCollectStores } = storeQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const isEnabled = !popupState.collapsed &&
        !!((_a = locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch) === null || _a === void 0 ? void 0 : _a.location) &&
        locationSearchParams.locationSearch.state !== 'INIT';
    const storesQueryResult = useQueries({
        queries: [
            getClickAndCollectStores({
                location: ((locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch) || {}).location,
                inStore: true,
                allowMultiFascia: false,
                sortBy: (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.sortBy) || 'distance',
                selectedStoreId: (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch.type) === LocationSearchType.CUSTOM_SEARCH
                    ? undefined
                    : inStoreFilter === null || inStoreFilter === void 0 ? void 0 : inStoreFilter.storeId,
            }, { enabled: isEnabled }),
            {
                queryKey: ['productCountPerStore', locationSearchParams, urlState],
                queryFn: () => SearchAPI.getProductCountPerStore(servicesEndpoint, authenticationConfig, undefined, urlState, isShopLanding, getAppliedFilters()),
                enabled: isEnabled,
            },
        ],
        combine: data => {
            var _a, _b;
            const [storesQueryResult, productCountPerStoreResult] = data;
            if (((_a = storesQueryResult.data) === null || _a === void 0 ? void 0 : _a.length) && ((_b = productCountPerStoreResult.data) === null || _b === void 0 ? void 0 : _b.length)) {
                const itemCountByStoreId = new Map(productCountPerStoreResult.data.map(item => [item.storeId, item.itemCount]));
                return Object.assign(Object.assign({}, storesQueryResult), { data: storesQueryResult.data.map(store => (Object.assign(Object.assign({}, store), { itemsCount: itemCountByStoreId.get(store.storeId) }))) });
            }
            return storesQueryResult;
        },
    });
    const handleClosePopup = () => dispatch(basketActions.createCCPopupCloseAction());
    const storeFilterApplied = () => dispatch(analyticsActions.storeFilterApplied());
    useEffect(() => {
        const inStoreFilterStorage = LocalStorageUtil.getJsonItem(SELECTED_STORE_STORAGE_KEY);
        if (!activeStoreId &&
            inStoreFilterStorage &&
            (!inStoreFilter || (inStoreFilter === null || inStoreFilter === void 0 ? void 0 : inStoreFilter.storeId) !== inStoreFilterStorage.storeId)) {
            updateInStoreFilter(inStoreFilterStorage);
        }
    }, [inStoreFilter]);
    const getAppliedFilters = () => {
        var _a;
        const appliedFilters = ((_a = urlState === null || urlState === void 0 ? void 0 : urlState.filter) === null || _a === void 0 ? void 0 : _a.length)
            ? urlState.filter.map(filter => `${filter.filterOn}:${filter.filterValue}`)
            : [];
        return (urlState === null || urlState === void 0 ? void 0 : urlState.defaultFilter) ? appliedFilters.concat(urlState.defaultFilter) : appliedFilters;
    };
    const handleSearch = (searchParams) => {
        setLocationSearchParams(searchParams);
    };
    const handleAddToFilter = (store) => {
        const { storeId, storeName } = store;
        updateStoreId(storeId);
        updateInStoreFilter({ storeId, storeName });
        storeFilterApplied();
        LocalStorageUtil.setItem(SELECTED_STORE_STORAGE_KEY, { storeId, storeName });
    };
    return (_jsx(StoreFinderPopup, { isOpen: !popupState.collapsed, urlInfo: urlState, type: StoreFinderType.IN_STORE_FILTER, onSearch: handleSearch, storesQueryResult: storesQueryResult, handleClosePopup: handleClosePopup, onStoreSelect: handleAddToFilter }));
};
